import React from "react";
import { LevaLogo } from "../svgs/leva-logo";
import { BackgroundSvg } from "../svgs/background";

export const AuthWrapper = ({ children }) => {
  return (
    <>
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
        }}
      >
        <BackgroundSvg />
      </div>

      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "24px",
        }}
      >
        <div
          style={{
            borderRadius: "20px",
            maxWidth: "342px",
            backgroundColor: "white",
            padding: "24px",
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <LevaLogo mb="24px" />

          {children}
        </div>
      </div>
    </>
  );
};
